import React, { useEffect, useState } from "react";
import { NavLink, useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";
import { useAuth } from "../../../Context/store/context";
import { _get } from "../../../../apiClient";
import { _showToast } from "../../../../toastHelper";
import InvitationType from "./InvitationType";
import globals from "../../../../globals";


export default function InvitationTypes() {
  const { showLoader, hideLoader, getToken, updateTitleAndIcon, logoutuser } = useAuth();
  const [eventCategories, setEventCategories] = useState([]);
  const userDetails = useSelector((state) => state.admininfo.admininfo);
  const navigate = useNavigate();

  useEffect(() => {
    if (!getToken())
      logoutuser();
    updateTitleAndIcon(globals.invitationType.title, globals.invitationType.icon);
  }, []);

  useEffect(() => {
    if (userDetails)
      checkStatus();
  }, [userDetails]);

  const checkStatus = async () => {
    showLoader();
    await _get(`/events/check-status`)
      .then(async () => {
        hideLoader();
        await fetchEventTypes();
      })
      .catch((error) => {
        hideLoader();
        _showToast(error, "error");
        return navigate("/invitations")
      });
  }


  const fetchEventTypes = async () => {
    showLoader();
    await _get("/categories/all?isForDemo=false")
      .then((response) => {
        setEventCategories(response);
        hideLoader();
      })
      .catch((error) => {
        hideLoader();
        _showToast(error, "error");
      })
  }
  return (
    <div className="content-wrapper">
      <div className="container-xxl flex-grow-1 container-p-y">
        <div className="card mb-3">
          <div className="card-body">
            <nav aria-label="breadcrumb">
              <ol className="breadcrumb breadcrumb-style1 mb-0">
                <li className="breadcrumb-item">
                  <NavLink to="/dashboard" className="text-gray">
                    Dashboard
                  </NavLink>
                </li>
                <li className="breadcrumb-item">
                  <NavLink to="/invitations" className="text-gray">
                    My Invitations
                  </NavLink>
                </li>
                <li className="breadcrumb-item text-primary">Invitation Type</li>
              </ol>
            </nav>
          </div>
        </div>

        <div className="row g-3">
          {eventCategories &&
            eventCategories.map((category, index) => {
              return <InvitationType evnetType={category} key={index} />
            })
          }
        </div>
      </div>
    </div>
  );
}
